import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { TEXT_PART_TOP_PADDING } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/threeUp/helpers/ThreeUpLayoutPortrait';
import { Flex } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

import { ThreeUpMoreCta } from './ThreeUpMoreCta';
import { ThreeUpParagraph } from './ThreeUpParagraph';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
};

export const ThreeUpTextPortrait = observer(function ThreeUpTextPortrait({
  gridCard,
}: Props) {
  const { data } = gridCard;
  const { textPart } = data!.styles!;
  const { position, paragraphs, paragraphSizes } = textPart;

  return (
    <group position={[position.x, position.y, 0]}>
      <Flex
        position={[0, 0, 0]}
        flexDirection='column'
        size={[
          textPart.textContentsContainer.width,
          textPart.textContentsContainer.height,
          0,
        ]}
        justifyContent='center'
        alignItems='flex-start'
        centerAnchor
        paddingTop={TEXT_PART_TOP_PADDING}
      >
        {paragraphs.map((paragraph, index) => (
          <ThreeUpParagraph
            key={index + paragraph.text}
            textProps={paragraph}
            index={index}
            height={paragraphSizes![index].height}
            marginTop={paragraph.lineHeight! * paragraph.fontSize!}
          />
        ))}
        {Boolean(data?.dtoData.linkButtonUrl) &&
          Boolean(data?.dtoData.linkButtonTitle) && (
            <ThreeUpMoreCta gridCard={gridCard} marginTop={20} />
          )}
      </Flex>
    </group>
  );
});
